import { useCallback } from "react";
import { adminApi as api } from "../../../../util/api";
import { ImportModal } from "../../../components/ImportModal";
import { snakifyKeys } from "../../../../util/helpers";

export const ImportOnshoreConfigurationsModal = ({ onImport, ...rest }) => {
  const handleImport = useCallback(
    async (values) => {
      const params = {
        file: {
          bytes: values.file,
        },
      };

      const res = await api.post("/admin/onshore_configurations/background_import.json", snakifyKeys(params));

      onImport?.(res.data?.meta?.message, res.data?.meta?.error_details);
    },
    [onImport]
  );

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Import Onshore Configurations"
      exampleDownloadPath="/admin/onshore_configurations/example"
    />
  );
};
